import {openDialog} from 'platform/components';
import {Link} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {VehicleHistoryControlConfig} from '../types/VehicleHistoryControlConfig';
import {VehicleHistoryDialog} from './VehicleHistoryDialog';

export interface VehicleHistoryProps extends TestIdProps {
  vehicleHistory: VehicleHistoryControlConfig;
}

const DIALOG_ID = 'vehicleHistoryDialog';

export function VehicleHistory(props: VehicleHistoryProps) {
  const handleClick = () =>
    openDialog(
      <VehicleHistoryDialog
        {...props.vehicleHistory}
        data-testid={suffixTestId('vehicleHistory-dialog', props)}
      />,
      {
        id: DIALOG_ID,
        title: i18n.t('entity.header.labels.vehicleHistory'),
        size: 'large',
      }
    );

  return (
    <Link
      size="small"
      leftIcon="action/history"
      title={i18n.t('entity.header.labels.vehicleHistory')}
      onClick={handleClick}
      data-testid={suffixTestId('vehicleHistory', props)}
    />
  );
}
